<script>
import options from "./NykForm.options"
export default options
</script>

<template>
  <div class="nyk-form custom-form">
    <form @submit.prevent="onSubmit">
      <div  
        v-for="element in formElements" 
        :key="element.key" 
        class="nyk-form__element" >
        <component
            v-if="isVisible(element)"
            :is="getComponentType(element)"
            v-bind="getElementProps(element)"
            v-on="getElementEvents(element)"
          />
      </div>

      <nyk-alert v-if="showStatusMessage" :type="submissionSucceeded ? 'success' : 'error'">
        <div v-html="submissionSucceeded ? submitSuccessMessage : submitErrorMessage"></div>
      </nyk-alert>
    </form>
  </div>
</template>